import Typography from "@/Utility/Typography";

const BoardColumn = ({ title, colorClass, count, children }) => {
  return (
    <div
      className={`flex h-full min-h-[calc(100dvh-13rem)] w-full min-w-0 flex-col overflow-hidden rounded-lg p-3 mt-4 ${colorClass}`}
    >
      <div className="flex items-center justify-between mb-3">
        <Typography variant="span2" className="text-sm font-semibold" component="span">
          {title}
        </Typography>

        {typeof count === "number" && (
          <Typography variant="span2" className="text-lg text-sm font-semibold" component="span">
            {count}
          </Typography>
        )}
      </div>

      {children}
    </div>
  );
};

export default BoardColumn;
